import { useState, useContext, useMemo, createContext } from 'react';

export function UnitsProvider(props) {
  const [units, setUnits] = useState('cm');
  const ctx = useMemo(
    () => ({
      units,
      setUnits,
    }),
    [units, setUnits]
  );
  return (
    <UnitsContext.Provider value={ctx}>{props.children}</UnitsContext.Provider>
  );
}

export function useUnits() {
  return useContext(UnitsContext);
}

const UnitsContext = createContext({
  units: 'cm',
  setUnits: () => {},
});
